import React from "react";
import MainLayout from "../../layouts/MainLayout";
import ServiceSectionNew from "./ServiceSectionNew";

const ServicePageNew = () => {
  return (
    <MainLayout>
      <ServiceSectionNew />
    </MainLayout>
  );
};

export default ServicePageNew;
